import api from "./api";

const USERS_URL = "vibbrante/users";

export const updateProfileUser = (vibbrante) => api.put(`${USERS_URL}/0`, { vibbrante });

export default {
  updateProfileUser
};
